import React, { useContext } from "react";
import { ModalStore } from "./ModalStore";

export const ModalContext = React.createContext<ModalStore>(null);

export function useModalStore() {
  return useContext(ModalContext);
}
